module.exports = __webpack_public_path__ + "static/media/plus-icon.b680360e.svg";